// extracted by mini-css-extract-plugin
export default {"step":"SetNewPasswordRecovery_step--y7S","backButton":"SetNewPasswordRecovery_backButton--Jhr"};